module.exports = __webpack_public_path__ + "img/9.ae16f531.jpg";